import React from 'react'
import PropTypes from 'prop-types'


export default class RadioBoolean extends React.Component {
  static propTypes = {
    firstLabel: PropTypes.string,
    secondLabel: PropTypes.string,
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    hasError: PropTypes.bool,
    errorLabel: PropTypes.string,
    className: PropTypes.string,
    labelClassName: PropTypes.string
  }

  static defaultProps = {
    firstLabel: 'Yes',
    secondLabel: 'No',
    className: ''
  }

  state = {
    defaultLoaded: false,
    selectedOption: ''
  }

  handleOptionChange = (e) => {
    this.setState({
      selectedOption: e.target.value,
      defaultLoaded: true
    })

    this.props.onChange(e.target.value);
  }

  render() {
    const { firstLabel, secondLabel, name, value, disabled, hasError, errorLabel, className, labelClassName } = this.props

    const firstValue = firstLabel.toLowerCase()
    const secondValue = secondLabel.toLowerCase()

    if (!this.state.defaultLoaded) {
      return (
        <div>
          <fieldset className={`slds-form-element${this.props.hasError ? ' slds-has-error' : ''} ${className}`}>
            <div className='slds-form-element__control'>
              <RadioOption
                id={`${name}_${firstValue}`}
                label={firstLabel}
                value={firstValue}
                onChange={this.handleOptionChange}
                name={name}
                checked={value}
                disabled={disabled}
                className={labelClassName}
              />
              <RadioOption
                id={`${name}_${secondValue}`}
                label={secondLabel}
                value={secondValue}
                onChange={this.handleOptionChange}
                name={name}
                checked={!value}
                disabled={disabled}
                className={labelClassName}
              />
            </div>
            {hasError &&
              <div className='slds-form-element__help'>
                {errorLabel}
              </div>
            }
          </fieldset>
        </div>
      )
    } else {
      return (
        <div>
          <fieldset className={`slds-form-element${hasError ? ' slds-has-error' : ''} ${className}`}>
            <div className='slds-form-element__control'>
              <RadioOption
                id={`${name}_${firstValue}`}
                label={firstLabel}
                value={firstValue}
                onChange={this.handleOptionChange}
                name={name}
                checked={this.state.selectedOption === firstValue}
                disabled={disabled}
                className={labelClassName}
              />
              <RadioOption
                id={`${name}_${secondValue}`}
                label={secondLabel}
                value={secondValue}
                onChange={this.handleOptionChange}
                name={name}
                checked={this.state.selectedOption === secondValue}
                disabled={disabled}
                className={labelClassName}
              />
            </div>
            {hasError &&
              <div className='slds-form-element__help'>
                {errorLabel}
              </div>
            }
          </fieldset>
        </div>
      )
    }

  }
}

function RadioOption(props) {
  return (
    <span className='slds-radio'>
      <input
        type='radio'
        {...props} />
      <label className='slds-radio__label' htmlFor={props.id}>
        <span className='slds-radio--faux'></span>
        <span className={`slds-form-element__label ${props.className}`}>{props.label}</span>
      </label>
    </span>
  )
}



// WEBPACK FOOTER //
// ./src/components/radio-boolean/index.js